import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { GlobalContext } from "../../../Contexts/GlobalContextProvider";
import BootstrapTable from "react-bootstrap-table-next";
import MerchandiseCardModal from "./MerchandiseCardModal";
import { reportingServices } from "../../../Services/AccountingServices/reporting.service";
import { AuthContext } from "../../../Contexts/AuthContext";
import SpinnerLoading from "../../Common/SpinnerLoading";
import { dateFormatter } from "../../../Helpers/DateHelper";
import { useHistory } from "react-router-dom";
import TrafficFilters from "./Filters/TrafficFilters";
import paginationFactory from "react-bootstrap-table2-paginator";

const Traffic = () => {
  const { t: translator } = useTranslation();
  const { tenantId, useAccounting } = useContext(AuthContext);
  const {
    isMobile,
    updateLocName,
    updateLocPos,
    updateLocTenant,
    updateLocStore,
    updateLocTab,
  } = useContext(GlobalContext);
  const history = useHistory();

  const [trafficData, setTrafficData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [update, setUpdate] = useState(false);
  const [productDetails, setProductDetails] = useState();
  const [showMerchandiseCard, setShowMerchandiseCard] = useState(false);

  const [filters, setFilters] = useState({
    tenantId: tenantId,
    storeTag: null,
    productGuid: null,
    productGroups: null,
    documentTypeId: null,
    from: null,
    to: null,
  });

  useEffect(() => {
    if (!useAccounting) history.push("/error-page/401");
    updateLocName("traffic");
    updateLocTenant(0);
    updateLocStore(0);
    updateLocPos(0);
    updateLocTab(0);
  }, []);

  useEffect(() => {
    if (update) {
      setIsLoading(true);
      reportingServices
        .getProductTransactionsCumulative(filters)
        .then((res) => {
          setIsLoading(false);
          setTrafficData(res?.data?.data);
        })
        .catch((err) =>
          console.log("Error while fetching traffic table. ", err),
        );
    }
  }, [update]);

  const exportExcelFunction = () => {
    reportingServices.exportXLSXProductTransactionsCumulative(
      filters,
      `Traffic-${dateFormatter(filters.from)}-${dateFormatter(filters.to)}`,
    );
  };

  const columns = [
    {
      dataField: "productName",
      text: translator("Traffic-TableHeader-Article"),
      sort: true,
    },
    {
      dataField: "productGroupName",
      text: translator("Traffic-TableHeader-ArticleGroup"),
      sort: true,
      hidden: Boolean(isMobile),
    },
    {
      dataField: "transactionDate",
      text: translator("Traffic-TableHeader-Date"),
      formatter: dateFormatter,
      sort: true,
      hidden: Boolean(isMobile),
    },
    {
      dataField: "documentTypeName",
      text: translator("Traffic-TableHeader-DocumentType"),
      sort: true,
      hidden: Boolean(isMobile),
    },
    {
      dataField: "storeDescription",
      text: translator("Traffic-TableHeader-SellingSpot"),
      sort: true,
      hidden: Boolean(isMobile),
    },
    {
      dataField: "totalQuantityIn",
      text: translator("Traffic-TableHeader-In"),
      sort: true,
    },
    {
      dataField: "totalQuantityOut",
      text: translator("Traffic-TableHeader-Out"),
      sort: true,
    },
    {
      dataField: "totalQuantityDiff",
      text: translator("Traffic-TableHeader-Diff"),
      sort: true,
    },
  ];
  return (
    <div className="p-2 pt-3">
      <div className="card container-fluid p-0">
        <div className="card-header card-wrap">
          <span>{translator("Main-Sidebar-Traffic")}</span>
          {trafficData?.length > 0 && (
            <span className="badge badge-pill badge-primary ml-2">
              {trafficData.length}
            </span>
          )}
        </div>
        <div className="card-body">
          <TrafficFilters
            filters={filters}
            setFilters={setFilters}
            updateTable={setUpdate}
          />
          {isLoading ? (
            <div className="dashboard-card-spinner">
              <SpinnerLoading />
            </div>
          ) : (
            trafficData && (
              <>
                <BootstrapTable
                  keyField="id"
                  data={trafficData}
                  columns={columns}
                  rowClasses="bootstrap-table-row"
                  noDataIndication={translator("No-Data")}
                  rowEvents={{
                    onClick: (e, row) => {
                      setShowMerchandiseCard(true);
                      setProductDetails(row);
                    },
                  }}
                  pagination={paginationFactory({ hideSizePerPage: true })}
                />
                <button
                  className="btn btn-secondary pull-left  mt-2"
                  type="submit"
                  onClick={exportExcelFunction}
                >
                  {/* <span className="icon icon-search"></span>{" "} */}
                  {translator(".XLSX")}
                </button>
              </>
            )
          )}
        </div>
      </div>
      <MerchandiseCardModal
        show={showMerchandiseCard}
        filters={filters}
        productDetails={productDetails}
        handleClose={() => setShowMerchandiseCard(false)}
      />
    </div>
  );
};

export default Traffic;
